export default __webpack_public_path__ + "static/mongodb-69c2e0fa587b4837c8b0d0cfc3a6f135.svg";